<ng-template #collectionFilters>
    <div class="br-flex br-flex-wrap br-gap-2 br-items-center">
      <select class="br-form-select br-form-select--sm br-w-auto"
              [(ngModel)]="filterStatus" (ngModelChange)="reload()"
              aria-label="Status">
        <option value="">All statuses</option>
        <option value="Open">Open</option>
        <option value="Closed">Closed</option>
      </select>

      <select class="br-form-select br-form-select--sm br-w-auto"
              [(ngModel)]="filterAssigned" (ngModelChange)="reload()"
              aria-label="Assigned to">
        <option value="">Anyone</option>
        <option *ngFor="let u of users" [ngValue]="u.id">{{ u.name }}</option>
      </select>

    </div>
</ng-template>

<ng-container *workspaceView="'full'">
<section class="br-card br-card--dense workspace-page--full">
  <header class="br-card-header workspace-collection-header">
    <h1 class="workspace-page__title">Customer Service Cases</h1>
    <button type="button"
            class="br-btn br-btn--primary br-btn--sm workspace-collection-add"
            *ngIf="auth.hasPermission('Case.Manage')"
            (click)="openNewCaseDialog()">
      <br-icon>add</br-icon> New Case
    </button>
  </header>

  <div class="br-card-body workspace-page__body workspace-page__body--contained">

  <app-data-table class="workspace-page__panel" [(search)]="collectionSearch" #table [columns]="columns" [fetch]="fetch"
                  searchPlaceholder="Customer name or account #"
                  columnPickerKey="crm-cases"
                  [resizableColumns]="true"
                  emptyText="No case matches those filters.">

    <!-- Status and assignee are chosen values, not free text, so they keep
         their own controls. The customer search is gone from here on purpose:
         it fed the same `search` parameter the table's own box now owns, and
         two boxes doing one thing is two places to look when it misbehaves. -->
    <div dt-filters><ng-container *ngTemplateOutlet="collectionFilters"></ng-container></div>

    <ng-template dtCell="title" let-row>
      <a class="dt-link" (click)="goToCase(row.id)">{{ row.title }}</a>
    </ng-template>

    <ng-template dtCell="customerName" let-row>{{ row.customerName }}</ng-template>

    <ng-template dtCell="status" let-row>
      <mat-chip [ngClass]="row.status === 'Open' ? 'chip-pending' : 'chip-inactive'" disableRipple>
        {{ row.status }}
      </mat-chip>
    </ng-template>

    <ng-template dtCell="assignedToUserName" let-row>
      <span *ngIf="row.assignedToUserName">{{ row.assignedToUserName }}</span>
      <span *ngIf="!row.assignedToUserName" class="br-cell-empty">&#8212;</span>
    </ng-template>

    <ng-template dtCell="createdAt" let-row>{{ row.createdAt | date:'MMM d, y' }}</ng-template>

    </app-data-table>
  </div>
</section>
</ng-container>

<ng-container *workspaceView="'compact'">
  <section class="workspace-page workspace-page--full">
    <h1 class="workspace-page__title">Customer Service Cases</h1>

    <app-data-list #compactList [fetch]="fetch" [(search)]="collectionSearch">
      <div list-filters><ng-container *ngTemplateOutlet="collectionFilters"></ng-container></div>

      <ng-template dataListItem let-row>
        <strong>{{ row.title }}</strong>
        <div class="br-text-muted">{{ row.customerName }} · {{ row.status }}</div>
      </ng-template>
      <ng-template dataListDetail let-row>
        <div *ngIf="row.assignedToUserName">Assigned to: {{ row.assignedToUserName }}</div>
        <div>Created: {{ row.createdAt | date:'MMM d, y' }}</div>
      </ng-template>
    </app-data-list>
  </section>
</ng-container>
